import { authenticatedAxios } from '../backend.service'
const version = 'v2'
const paths = {
  getContrato: (id) => `${version}/contrato/${id}`,
  getContratos: `${version}/contrato`,
  getArchivoTerminosCondiciones: `${version}/contrato/terminos-condiciones-file`,
}

export const getContrato = async ({ id }) => {
  const response = await authenticatedAxios.get(paths.getContrato(id))
  return response
}

export const getContratos = async () => {
  const response = await authenticatedAxios.get(paths.getContratos)
  return response
}

export const getTerminosCondiciones = async () => {
  const response = await authenticatedAxios.get(paths.getArchivoTerminosCondiciones, { responseType: 'blob' })
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const contentDisposition = response.headers['content-disposition']
  let fileName = 'archivo.xlsx'
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/)
    if (match && match[1]) {
      fileName = match[1]
    }
  }

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  link.click()
}
